export const THEME_PC: { [key: number]: string } = {
  27: '2-1-3',
  33: '2-1-32'
}
